import React, { useState } from 'react';
import { EventDetailManagerProps } from './eventdetailmanager.props';
import EventDetailManagerView from './eventdetailmanager.view';

const EventDetailManager: React.FC<EventDetailManagerProps> = (props) => {
  const [activeSubTab, setActiveSubTab] = useState('race-types');

  return (
    <EventDetailManagerView
      {...props}
      activeSubTab={activeSubTab}
      setActiveSubTab={setActiveSubTab}
    />
  );
};

export default EventDetailManager;
